export const workstreamTimeline = {
  title: 'Project workstream timelines',
  subtitle:
    'One strand timeline per budget-tracker project. Drop items onto a month to date them, or into holding until a date is known.',
  untitled: 'Untitled timeline',
  create: 'Create timeline',
  open: 'Open timeline',
  backToList: 'All timelines',
  viewOnly: 'View only',
  owner: 'Owner',
  editor: 'Can edit',
  viewer: 'Can view',
  saving: 'Saving…',
  saved: 'Saved',
  hint: 'Drop on a month to date an item. Drop into holding to undate it. Empty months after a strand’s last booked item are hidden.',
  stats: {
    strands: 'strands',
    sections: 'sections',
    waiting: 'waiting',
    done: 'done',
    progress: 'in progress',
    blocked: 'blocked',
  },
  list: {
    emptyTitle: 'No project workstream timelines yet',
    emptyDescription:
      'Create a timeline for a budget-tracker project to plan strands, months, and holding-space items.',
    emptySharedTitle: 'No timelines shared with you',
    emptySharedDescription:
      'When a colleague shares a project workstream timeline with you, it will appear here.',
    updated: 'Updated {{date}}',
    sharedWithYou: 'Shared with you',
    count: 'timelines',
  },
  createDialog: {
    title: 'Create project workstream timeline',
    projectLabel: 'Project',
    nameLabel: 'Title',
    namePlaceholder: 'Usually the project name',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Optional context for collaborators',
    noProjects: 'Every budget-tracker project already has a workstream timeline.',
    aweWanderPrefill: 'Awe & Wander will open with the current booked-events plan.',
    submit: 'Create',
  },
  toolbar: {
    addSection: 'Add section',
    addStrand: 'Add strand',
    exportJson: 'Export JSON',
    importJson: 'Import JSON',
    share: 'Share',
    delete: 'Delete timeline',
  },
  strand: {
    namePlaceholder: 'Strand name',
    blurbPlaceholder: 'Strand description',
    colour: 'Strand colour',
    remove: 'Remove strand',
    removeConfirm: 'Remove this strand and its sections? This cannot be undone.',
    addDated: 'Add dated section',
    addWaiting: 'Add waiting item',
    holding: 'Holding',
    holdingBlurb: 'Not yet dated',
  },
  section: {
    titlePlaceholder: 'Section title',
    detailPlaceholder: 'Notes / detail',
    waitingFor: 'Waiting for',
    waitingPlaceholder: 'What needs to happen before this can be dated?',
    placeOn: 'Set a month to move this onto the timeline.',
    remove: 'Remove',
    drag: 'Drag to a month to date, or into holding to undate',
    when: 'When',
    status: 'Status',
  },
  status: {
    todo: 'To do',
    progress: 'In progress',
    done: 'Done',
    blocked: 'Blocked',
  },
  addDialog: {
    title: 'Add section',
    waitingTitle: 'Add waiting item',
    description: 'Creates a new block on the chosen strand timeline.',
    strand: 'Strand',
    titleLabel: 'Title',
    titlePlaceholder: 'e.g. Gorcott Hill site visit',
    when: 'When (month) — leave blank to add to holding',
    waitingFor: 'Waiting for (if undated)',
    waitingPlaceholder: 'e.g. 26 Aug meeting; Alex to confirm dates',
    submit: 'Add',
  },
  share: {
    title: 'Share timeline',
    description:
      'People with Edit can change the board. People with View can open it but not change it. Org admins can always open every timeline.',
    addLabel: 'Add people',
    addPlaceholder: 'Search colleagues',
    permission: 'Permission',
    edit: 'Edit',
    view: 'View',
    add: 'Add',
    copyLink: 'Copy signed-in link',
    linkCopied: 'Link copied',
    noPeople: 'No one else has access yet.',
    remove: 'Remove',
    you: 'You',
    publicTitle: 'Anyone with the link',
    publicDescription:
      'Turn this on to share a view-only board with people who do not have an OVERHEAR account. They cannot edit, and they will not see the list of other projects.',
    publicEnabled: 'Public view link is on',
    publicDisabled: 'Public view link is off',
    publicCopy: 'Copy public view link',
  },
  delete: {
    title: 'Delete this timeline?',
    message: 'This removes the timeline for everyone it is shared with. This cannot be undone.',
    confirm: 'Delete timeline',
  },
  accessDenied: {
    title: 'You do not have access',
    description: 'Ask the owner to share this timeline with you as Edit or View.',
  },
  notFound: {
    title: 'Timeline not found',
    description: 'It may have been deleted, or the link is incorrect.',
  },
  publicView: {
    title: 'Shared workstream timeline',
    invalid: 'This view link is invalid.',
    missing: 'This shared timeline is unavailable. The link may have been turned off.',
  },
};

export type WorkstreamTimelineTranslations = typeof workstreamTimeline;
